import { useState } from 'hooks'
import $ from 'jquery'
import { useEvent } from '@/core'
import { getReportingColorAndValueByContainer, getReportingColorSettingSelectors } from './reporting-color.selector'
import { constants } from './reporting-color.constant'

type State = {
	colorSettingsBlock?: HTMLElement
	colorSettingContainers?: NodeListOf<HTMLElement>
}

export const ReportingColorSetting = (() => {
	const { state, setState } = useState<State>()

	const initChangeEvent = (changeListener: HTMLInputElement, affectedByChange: HTMLInputElement) => {
		const { colorSettingsBlock } = state
		if (!colorSettingsBlock) return

		const changeEvent = useEvent(changeListener, 'change')

		changeEvent.register(() => {
			affectedByChange.value = changeListener.value
			M.updateTextFields()

			// @ts-ignore
			$.nette.ajax({
				type: 'POST',
				url: colorSettingsBlock.getAttribute(constants.selector.colorHandlers),
				data: {
					color: affectedByChange.value,
					key: affectedByChange.getAttribute('data-key'),
				},
			})
		})
	}

	const initColorChange = () => {
		const { colorSettingContainers } = state
		if (!colorSettingContainers) return

		for (let i = 0; i < colorSettingContainers.length; i++) {
			const { color, value } = getReportingColorAndValueByContainer(colorSettingContainers[i])
			if (!color || !value) continue

			initChangeEvent(color, value)
			initChangeEvent(value, color)
		}
	}

	const init = () => {
		setState({ ...getReportingColorSettingSelectors() })
		initColorChange()
	}

	return {
		init,
	}
})()
